
import { useAuth } from "@/hooks/useAuth";
import { DoctorDashboard } from "./DoctorDashboard";
import { PatientDashboard } from "./patient/PatientDashboard";

const Dashboard = () => {
  const { profile } = useAuth();

  // Show doctor dashboard for doctors and admin, patient dashboard for patients
  if (profile?.role === "doctor" || profile?.role === "admin") {
    return <DoctorDashboard />;
  }

  // For any other role or undefined role, show patient dashboard
  return <PatientDashboard />;
};

export default Dashboard;
